import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const UPDATE_QUERY = print(gql`
  mutation UpsertPrice($data: CreatePriceWithAdmissionWaInput!) {
    upsertPrice(data: $data) {
      id
    }
  }
`);

export const responseUpdateKey = "upsertPrice";
export interface UpdateGql {
  upsertPrice: {
    id: number;
  };
}
